

const initialState = ({
    pl: {
        "Mężczyzna": "Mężczyzna",
        "Kobieta": "Kobieta",
        "Luksusowe": "Luksusowe",
        "man": "Mężczyzna",
        "woman": "Kobieta",
        "homepage": "Strona główna",
        "about": "O nas",
        "contact": "Kontakt",
        "stores": "Sklep",
        "policy": "Polityka prywatności",
        "terms": "Regulamin",
        "returns": "Zwroty",
        "shipping": "Dostawa",
        "cart": "Koszyk",
        "add_to_cart": "Dodaj do koszyka",
        "add_to_wishlist": "Dodaj do listy życzeń",
        "add_to_compare": "Dodaj do porównania",
        "links": "Linki",
        "categories": "Kategorie",
        "informations": "Informacje",
        "luxury": "Luksusowe",
        "new_arrivals": "Nowość",
        "featured_products": "Polecane",
        "products_in_cart": "Produkty w koszyku",
        "subtotal": "Suma",
        "register": "Zarejestruj się",
        "regulations": "Regulamin",
        "reset_cart": "Zresetuj koszyk",
        "title_az": "Tytuł (A-Z)",
        "title_za": "Tytuł (Z-A)",
        "price_high_low": "Cena (od najwyższej)",
        "price_low_high": "Cena (od najniższej)",
        "profile": "Profil",
        "login": "Zaloguj się",
        "logout": "Wyloguj się",
        "checkout": "Zamówienie",
        "first_name": "Imię",
        "last_name": "Nazwisko",
        "phone": "Telefon",
        "company": "Firma",
        "postal_code": "Kod pocztowy",
        "address": "Adres",
        "city": "Miasto",
        "country": "Kraj",
        "place_order": "Złóż zamówienie",
        "order_summary": "Podsumowanie zamówienia",
        "shipping_next": "Dostawa naliczona w następnym kroku",
        "platnosc": "Płatność",
        "bezpieczenstwo": "Bezpieczeństwo",
        "dostawa": "Dostawa",
        "invoices": "Faktury",
        "your_cart_products": "Twoje produkty",
        "cart_is_empty": "Twój koszyk jest pusty.",
        "continue_shopping": "Kontynuuj zakupy",
        "remove_item": "Usuń",
        "shipping_at_checkout": "Koszt wysyłki obliczany przy kasie.",
        "add_to_bag": "Dodaj do koszyka",
        "discover_collection": "Odkryj kolekcję",
        "essences_eyebrow": "Rodziny zapachowe",
        "essences_title": "Odkryj esencję dla siebie",
        "reviews_cta": "Poznaj opinie klientów lub oceń nasz sklep",
        "reviews_heading": "Opinie",
        "read_reviews": "Czytaj opinie",
        "add_review": "Dodaj opinię",
        "no_reviews": "Brak recenzji. Bądź pierwszy, który zostawi opinię!",
        "rate_product": "Oceń nasz produkt!",
        "rate_store": "Oceń nasz sklep!",
        "review_title_placeholder": "Tytuł",
        "review_name_placeholder": "Twoje imię",
        "review_comment_placeholder": "Jakie są Twoje uwagi?",
        "submit_review": "Wyślij opinię",
        "review_success_message": "Dziękujemy! Twoja recenzja oczekuje na zatwierdzenie.",
        "review_login_required": "Musisz być zalogowany, aby dodać recenzję.",
        "review_submit_error": "Nie udało się dodać recenzji.",
        "review_error_prefix": "Wystąpił błąd: ",
        "wishlist_title": "Twoja lista życzeń",
        "wishlist_create_prompt": "Chcesz stworzyć listę życzeń?",
        "wishlist_join_cta": "Dołącz do nas i utwórz swoją listę życzeń!",
        "wishlist_have_account": "Masz już konto?",
        "wishlist_login_cta": "Zaloguj się i utwórz swoją listę życzeń!",
        "wishlist_desc": "Twoje produkty zapisane na później",
        "wishlist_empty": "Twoja lista życzeń jest pusta",
        "wishlist_start_shopping": "Rozpocznij zakupy",
        "profile_my_orders": "Moje zamówienia",
        "profile_my_addresses": "Moje adresy",
        "profile_my_invoices": "Moje faktury",
        "profile_settings": "Ustawienia",
        "profile_logout": "Wyloguj",
        "profile_order_history": "Historia zamówień",
        "profile_addresses_heading": "Adresy",
        "profile_no_addresses": "Nie dodano adresów",
        "edit": "Edytuj",
        "delete": "Usuń",
        "wishlist_login_required": "Zaloguj się, aby dodać do listy życzeń.",
        "wishlist_added": "Dodano do listy życzeń!",
        "wishlist_already_added": "Produkt już na liście życzeń.",
        "wishlist_add_failed": "Błąd dodawania do listy życzeń.",
        "wishlist_view_product": "Zobacz produkt",
        "wishlist_remove": "Usuń z listy",
        "wishlist_remove_failed": "Nie udało się usunąć z listy życzeń.",
        "loading": "Ładowanie...",
        "product_not_found": "Nie znaleziono produktu!",
        "out_of_stock": "Brak w magazynie!",
        "add_to_cart_prefix": "Dodaj do koszyka - ",
        "ratings_and_reviews": "Oceny i recenzje",
        "notes_accordion_title": "NUTY ZAPACHOWE",
        "composition_accordion_title": "SKŁAD",
        "how_to_use_accordion_title": "JAK UŻYWAĆ",
        "shipping_accordion_title": "WYSYŁKA",
        "top_notes_label": "Pierwsze nuty, które poczujesz:",
        "heart_notes_label": "Serce perfum:",
        "base_notes_label": "Nuty, które utrzymują się przez cały dzień:",
        "reviews_count_suffix": "recenzji",
        "similar_products_heading": "Spodobają Ci się również:",
        "add_button_short": "Dodaj",
        "menu": "Menu",
        "search": "Szukaj",
        "search_placeholder": "Szukaj zapachów…",
        "close": "Zamknij",
        "cancel": "Anuluj",
        "account": "Konto",
        "account_not_logged_in": "Nie jesteś zalogowany.",
        "account_login_prompt": "Zaloguj się lub załóż konto:",
        "login_heading": "Logowanie",
        "login_intro": "Wprowadź swoje dane, aby się zalogować.",
        "login_identifier_placeholder": "Email lub nazwa użytkownika",
        "password_placeholder": "Hasło",
        "email_placeholder": "Adres e-mail",
        "username_placeholder": "Nazwa użytkownika",
        "forgot_password": "Zapomniałeś hasła?",
        "reset_password_heading": "Resetowanie hasła",
        "sending": "Wysyłanie...",
        "send_reset_link": "Wyślij link resetujący",
        "back_to_login": "Powrót do logowania",
        "forgot_password_sent": "Jeśli konto istnieje dla tego adresu e-mail, wysłaliśmy link do zmiany hasła.",
        "forgot_password_send_failed": "Nie udało się wysłać wiadomości resetującej.",
        "login_failed": "Nieprawidłowy login lub hasło.",
        "network_error": "Błąd połączenia. Spróbuj ponownie.",
        "register_heading": "Rejestracja",
        "register_intro": "Wypełnij formularz, aby założyć konto.",
        "register_success": "Konto utworzone! Jeśli adres e-mail jest poprawny, wyślemy wiadomość potwierdzającą.",
        "register_failed": "Nie udało się założyć konta. Sprawdź dane lub skontaktuj się z nami.",
        "register_taken": "Ten e-mail lub nazwa użytkownika są już zajęte.",
        "checkout_choose_mode": "Wybierz sposób złożenia zamówienia:",
        "checkout_login_or_register": "Zaloguj się / Załóż konto",
        "checkout_as_guest": "Kontynuuj jako gość",
        "section_bestsellers": "Bestsellery",
        "page_title_order_status": "Status zamówienia",
        "page_title_payment": "Płatność",
        "section_new": "Nowości",
        "generic_error": "Coś poszło nie tak!",
        "featured_desc_new": "Sprawdź nasze najnowsze dodatki do kolekcji.",
        "featured_desc_bestsellers": "Odkryj naszą ekskluzywną kolekcję, z wyjątkowymi produktami.",
        "stock_limit_reached": "Masz już w koszyku wszystkie dostępne sztuki ({count}).",
        "added_to_cart": "Dodano do koszyka: {title}",
        "out_of_stock_short": "Niedostępny",
        "back": "Wstecz",
        "next": "Dalej",
        "none": "Brak",
        "quantity": "Ilość",
        "processing": "Przetwarzanie...",
        "back_to_home": "Wróć do strony głównej",
        "go_to_my_orders": "Przejdź do Moje zamówienia",
        "order_placed_title": "Zamówienie zostało złożone",
        "order_placed_guest": "Dziękujemy za złożenie zamówienia! Szczegóły zamówienia wysłaliśmy na podany adres e-mail.",
        "order_placed_user": "Dziękujemy za złożenie zamówienia! Sprawdź jego status w zakładce <b>Moje zamówienia</b>.",
        "bank_transfer_heading": "Dane do przelewu",
        "bank_transfer_intro": "Prosimy o dokonanie przelewu na poniższe konto:",
        "bank_transfer_account": "Numer konta",
        "bank_transfer_amount": "Kwota",
        "bank_transfer_title": "Tytuł przelewu",
        "bank_transfer_order_title": "Zamówienie #{id}",
        "bank_transfer_pending": "Zamówienie oczekuje na płatność. Potwierdzimy je po zaksięgowaniu przelewu.",
        "checkout_step_cart": "Twój koszyk",
        "checkout_step_shipping": "Dane do wysyłki",
        "checkout_step_payment": "Dostawa i płatność",
        "checkout_go_to_shipping": "Przejdź do danych wysyłki",
        "checkout_go_to_payment": "Przejdź do dostawy i płatności",
        "checkout_choose_shipping": "1. Wybierz sposób dostawy",
        "checkout_choose_payment": "2. Wybierz sposób płatności",
        "checkout_invalid_data": "Sprawdź dane do wysyłki i spróbuj ponownie.",
        "checkout_order_failed": "Nie udało się złożyć zamówienia. Spróbuj ponownie.",
        "checkout_out_of_stock": "Niektóre produkty nie są już dostępne w tej ilości: {products}. Zmień ilość w koszyku.",
        "place_order_and_pay": "Zamawiam i płacę ({total})",
        "place_order_with_total": "Złóż zamówienie ({total})",
        "shipping_dhl_courier_title": "Kurier DHL",
        "shipping_dhl_courier_desc": "Dostawa kurierem DHL w 1–2 dni robocze. Płatność online lub przelewem.",
        "shipping_dhl_cod_title": "Kurier DHL – za pobraniem",
        "shipping_dhl_cod_desc": "Dostawa kurierem DHL w 1–2 dni robocze. Płacisz kurierowi przy odbiorze.",
        "shipping_free": "Darmowa",
        "payment_cod_note": "Płatność przy odbiorze — zapłacisz kurierowi DHL przy doręczeniu paczki.",
        "payment_payu_title": "Płatność online PayU",
        "payment_payu_desc": "BLIK, karta płatnicza, Google Pay lub szybki przelew — wybierzesz na stronie PayU.",
        "payment_bank_transfer_title": "Przelew tradycyjny",
        "payment_bank_transfer_desc": "Dane do przelewu pokażemy po złożeniu zamówienia.",
        "summary_products": "Produkty",
        "summary_discount": "Rabat ({code})",
        "summary_shipping": "Dostawa",
        "summary_total": "Razem do zapłaty",
        "discount_placeholder": "Kod rabatowy",
        "discount_apply": "Zastosuj",
        "discount_remove": "Usuń kod rabatowy",
        "discount_invalid": "Ten kod jest nieprawidłowy lub wygasł.",
        "discount_min_order": "Kod obowiązuje od {amount}.",
        "free_shipping_from": "Darmowa dostawa od {amount}",
        "free_shipping_missing": "Brakuje {amount} do darmowej dostawy",
        "free_shipping_reached": "Masz darmową dostawę!",
        "shipping_details_heading": "Dane do wysyłki",
        "saved_address_select": "Wybierz zapisany adres",
        "want_invoice": "Chcę otrzymać fakturę VAT",
        "company_name": "Nazwa firmy",
        "nip": "NIP firmy",
        "error_required": "To pole jest wymagane.",
        "error_email": "Podaj poprawny adres e-mail, np. jan@example.pl.",
        "error_phone": "Nieprawidłowy numer dla wybranego kraju.",
        "error_first_name": "Imię może zawierać tylko litery.",
        "error_last_name": "Nazwisko może zawierać tylko litery.",
        "error_zip": "Kod pocztowy musi być w formacie 00-000.",
        "error_nip": "NIP musi mieć dokładnie 10 cyfr.",
        "shipping_info_title": "Metody wysyłki i płatności.",
        "shipping_info_subtitle": "Wysyłki",
        "shipping_info_country": "Polska",
        "shipping_info_dispatch": "Zamówienia złożone do godz. <b>14:00 (pon.–pt.)</b> wysyłamy tego samego dnia, późniejsze — w następny dzień roboczy.",
        "shipping_info_free": "Darmowa dostawa od <b>{amount}</b> — dla każdej metody dostawy.",
        "shipping_info_courier_payment": "Płatność online przez PayU (BLIK, karta, Google Pay) lub przelewem tradycyjnym.",
        "shipping_info_price": "Koszt dostawy: <b>{price}</b>",
        "shipping_info_more": "Dodatkowe informacje",
        "shipping_info_invoices": "Wystawiamy faktury VAT na żądanie.",
        "shipping_info_poland_only": "Zamówienia realizujemy tylko na terenie Polski.",
        "product_shipping_time": "Wysyłka w 24h (zamówienia złożone do 14:00 w dni robocze).",
        "product_shipping_free": "Darmowa dostawa od 200 zł.",
        "product_shipping_returns": "14 dni na bezpłatny zwrot.",
        "product_shipping_more": "Zobacz pełne informacje o wysyłce i płatnościach →",
        "how_to_use_step1": "Spryskaj perfumy z odległości 10–15 cm od skóry, celując w tzw. punkty pulsu: nadgarstki, szyję, dekolt.",
        "how_to_use_step2": "Nie pocieraj skóry po aplikacji – przyspiesza to rozpad nut zapachowych.",
        "how_to_use_step3": "Aplikuj na nawilżoną skórę, aby zapach utrzymywał się dłużej.",
        "how_to_use_step4": "Przechowuj w chłodnym, zacienionym miejscu, z dala od bezpośredniego światła słonecznego.",
        "ingredients_intro": "Nasze perfumy powstają z starannie dobranych esencji zapachowych rozpuszczonych w wysokiej jakości alkoholu kosmetycznym (Alcohol Denat.), bez dodatku barwników.",
        "ingredients_alcohol": "Alcohol Denat. – baza zapachowa",
        "ingredients_parfum": "Parfum (Fragrance) – kompozycja zapachowa",
        "ingredients_aqua": "Aqua (Water)",
        "ingredients_allergens": "Może zawierać: Limonene, Linalool, Citral – naturalne składniki zapachowe",
        "ingredients_note": "Pełny wykaz składników (INCI) znajduje się na etykiecie opakowania produktu.",
        "essences_show_more": "Pokaż więcej",
        "essences_show_less": "Pokaż mniej",
        "profile_add_address": "Dodaj adres",
        "address_save_failed": "Nie udało się zapisać adresu!",
        "cart_item_sold_out": "„{title}” jest już niedostępny — oznaczyliśmy go w koszyku.",
        "cart_item_reduced": "Zmniejszyliśmy ilość „{title}” do {count} — tyle mamy teraz na stanie.",
        "cart_has_unavailable": "W koszyku są niedostępne produkty. Usuń je, aby przejść dalej.",
        "cart_remove_unavailable": "Usuń niedostępne",
        "phone_country": "Kraj",
        "error_city_mismatch": "Ta miejscowość nie pasuje do kodu {zip}. Wybierz ją z listy.",
        "error_city_unknown": "Nie znamy takiej miejscowości. Sprawdź nazwę i kod pocztowy.",
        "city_pick_hint": "Wybierz miejscowość z listy dla tego kodu.",
        "shipping_poland_only_hint": "Wysyłamy tylko na terenie Polski.",
        "postal_data_attribution": "Dane kodów pocztowych: <geonames>© GeoNames</geonames>, licencja <license>CC BY 4.0</license>",
        "badge_new": "Nowe"
    },

    en: {
        "Mężczyzna": "Man",
        "Kobieta": "Woman",
        "Luksusowe": "Luxury",
        "man": "Man",
        "woman": "Woman",
        "homepage": "Homepage",
        "about": "About",
        "contact": "Contact",
        "stores": "Stores",
        "policy": "Privacy policy",
        "terms": "Terms",
        "returns": "Returns",
        "shipping": "Shipping",
        "cart": "Cart",
        "add_to_cart": "Add to cart",
        "add_to_wishlist": "Add to wishlist",
        "add_to_compare": "Add to compare",
        "links": "Links",
        "categories": "Categories",
        "informations": "Information",
        "luxury": "Luxury",
        "new_arrivals": "New arrivals",
        "featured_products": "Featured products",
        "products_in_cart": "Products in your cart",
        "subtotal": "Subtotal",
        "register": "Register",
        "reset_cart": "Reset cart",
        "title_az": "Title (A-Z)",
        "title_za": "Title (Z-A)",
        "price_high_low": "Price (high to low)",
        "price_low_high": "Price (low to high)",
        "profile": "Profile",
        "login": "Login",
        "logout": "Logout",
        "checkout": "Checkout",
        "first_name": "First name",
        "last_name": "Last name",
        "phone": "Phone",
        "company": "Company",
        "postal_code": "Postal code",
        "address": "Address",
        "city": "City",
        "country": "Country",
        "place_order": "Place order",
        "order_summary": "Order summary",
        "shipping_next": "Shipping calculated at the next step",
        "platnosc": "Payment",
        "bezpieczenstwo": "Security",
        "dostawa": "Delivery",
        "regulations": "Regulations",
        "invoices": "Invoices",
        "your_cart_products": "Your products",
        "cart_is_empty": "Your cart is empty.",
        "continue_shopping": "Continue shopping",
        "remove_item": "Remove",
        "shipping_at_checkout": "Shipping calculated at checkout.",
        "add_to_bag": "Add to bag",
        "discover_collection": "Discover the collection",
        "essences_eyebrow": "Olfactory families",
        "essences_title": "Discover your essence",
        "reviews_cta": "See customer reviews or rate our store",
        "reviews_heading": "Reviews",
        "read_reviews": "Read reviews",
        "add_review": "Add review",
        "no_reviews": "No reviews yet. Be the first to leave one!",
        "rate_product": "Rate our product!",
        "rate_store": "Rate our store!",
        "review_title_placeholder": "Title",
        "review_name_placeholder": "Your name",
        "review_comment_placeholder": "What are your thoughts?",
        "submit_review": "Submit review",
        "review_success_message": "Thank you! Your review is awaiting approval.",
        "review_login_required": "You must be logged in to add a review.",
        "review_submit_error": "Failed to add review.",
        "review_error_prefix": "An error occurred: ",
        "wishlist_title": "Your Wishlist",
        "wishlist_create_prompt": "Want to create a wishlist?",
        "wishlist_join_cta": "Join us and create your wishlist!",
        "wishlist_have_account": "Already have an account?",
        "wishlist_login_cta": "Log in and create your wishlist!",
        "wishlist_desc": "Your products saved for later",
        "wishlist_empty": "Your wishlist is empty",
        "wishlist_start_shopping": "Start shopping",
        "profile_my_orders": "My orders",
        "profile_my_addresses": "My addresses",
        "profile_my_invoices": "My invoices",
        "profile_settings": "Settings",
        "profile_logout": "Log out",
        "profile_order_history": "Order history",
        "profile_addresses_heading": "Addresses",
        "profile_no_addresses": "No addresses added",
        "edit": "Edit",
        "delete": "Delete",
        "wishlist_login_required": "Log in to add to wishlist.",
        "wishlist_added": "Added to wishlist!",
        "wishlist_already_added": "Product already in wishlist.",
        "wishlist_add_failed": "Failed to add to wishlist.",
        "wishlist_view_product": "View product",
        "wishlist_remove": "Remove",
        "wishlist_remove_failed": "Failed to remove from wishlist.",
        "loading": "Loading...",
        "product_not_found": "Product not found!",
        "out_of_stock": "Out of stock!",
        "add_to_cart_prefix": "Add to cart - ",
        "ratings_and_reviews": "Ratings and reviews",
        "notes_accordion_title": "FRAGRANCE NOTES",
        "composition_accordion_title": "COMPOSITION",
        "how_to_use_accordion_title": "HOW TO USE",
        "shipping_accordion_title": "SHIPPING",
        "top_notes_label": "The first notes you'll notice:",
        "heart_notes_label": "Heart of the fragrance:",
        "base_notes_label": "The notes that last all day:",
        "reviews_count_suffix": "reviews",
        "similar_products_heading": "You might also like:",
        "add_button_short": "Add",
        "menu": "Menu",
        "search": "Search",
        "search_placeholder": "Search fragrances…",
        "close": "Close",
        "cancel": "Cancel",
        "account": "Account",
        "account_not_logged_in": "You are not logged in.",
        "account_login_prompt": "Please log in or create an account:",
        "login_heading": "Log in",
        "login_intro": "Enter your details to log in.",
        "login_identifier_placeholder": "Email or username",
        "password_placeholder": "Password",
        "email_placeholder": "Email address",
        "username_placeholder": "Username",
        "forgot_password": "Forgot your password?",
        "reset_password_heading": "Reset password",
        "sending": "Sending...",
        "send_reset_link": "Send reset link",
        "back_to_login": "Back to login",
        "forgot_password_sent": "If an account exists for this email, we have sent a password reset link.",
        "forgot_password_send_failed": "Could not send the reset email.",
        "login_failed": "Invalid username or password.",
        "network_error": "Connection error. Please try again.",
        "register_heading": "Create account",
        "register_intro": "Fill in the form to create an account.",
        "register_success": "Account created! If your email is correct, we will send you a confirmation email.",
        "register_failed": "Could not create the account. Check your details or contact us.",
        "register_taken": "This email or username is already taken.",
        "checkout_choose_mode": "Choose how to place your order:",
        "checkout_login_or_register": "Log in / Create account",
        "checkout_as_guest": "Continue as guest",
        "section_bestsellers": "Bestsellers",
        "page_title_order_status": "Order status",
        "page_title_payment": "Payment",
        "section_new": "New arrivals",
        "generic_error": "Something went wrong!",
        "featured_desc_new": "Discover the latest additions to our collection.",
        "featured_desc_bestsellers": "Discover our exclusive collection of exceptional fragrances.",
        "stock_limit_reached": "You already have all available units in your cart ({count}).",
        "added_to_cart": "Added to cart: {title}",
        "out_of_stock_short": "Sold out",
        "back": "Back",
        "next": "Next",
        "none": "None",
        "quantity": "Quantity",
        "processing": "Processing...",
        "back_to_home": "Back to the homepage",
        "go_to_my_orders": "Go to My orders",
        "order_placed_title": "Your order has been placed",
        "order_placed_guest": "Thank you for your order! We have sent the details to your email address.",
        "order_placed_user": "Thank you for your order! You can follow its status in <b>My orders</b>.",
        "bank_transfer_heading": "Bank transfer details",
        "bank_transfer_intro": "Please make a transfer to the account below:",
        "bank_transfer_account": "Account number",
        "bank_transfer_amount": "Amount",
        "bank_transfer_title": "Transfer title",
        "bank_transfer_order_title": "Order #{id}",
        "bank_transfer_pending": "Your order is awaiting payment. We will confirm it once the transfer arrives.",
        "checkout_step_cart": "Your cart",
        "checkout_step_shipping": "Shipping details",
        "checkout_step_payment": "Delivery & payment",
        "checkout_go_to_shipping": "Continue to shipping details",
        "checkout_go_to_payment": "Continue to delivery & payment",
        "checkout_choose_shipping": "1. Choose delivery",
        "checkout_choose_payment": "2. Choose payment",
        "checkout_invalid_data": "Please check your shipping details and try again.",
        "checkout_order_failed": "We could not place your order. Please try again.",
        "checkout_out_of_stock": "Some products are no longer available in this quantity: {products}. Please update your cart.",
        "place_order_and_pay": "Place order and pay ({total})",
        "place_order_with_total": "Place order ({total})",
        "shipping_dhl_courier_title": "DHL courier",
        "shipping_dhl_courier_desc": "DHL courier delivery in 1–2 business days. Pay online or by bank transfer.",
        "shipping_dhl_cod_title": "DHL courier – cash on delivery",
        "shipping_dhl_cod_desc": "DHL courier delivery in 1–2 business days. Pay the courier on delivery.",
        "shipping_free": "Free",
        "payment_cod_note": "Cash on delivery — you pay the DHL courier when the parcel arrives.",
        "payment_payu_title": "Online payment with PayU",
        "payment_payu_desc": "BLIK, card, Google Pay or instant transfer — you choose on the PayU page.",
        "payment_bank_transfer_title": "Bank transfer",
        "payment_bank_transfer_desc": "We will show the transfer details after you place the order.",
        "summary_products": "Products",
        "summary_discount": "Discount ({code})",
        "summary_shipping": "Delivery",
        "summary_total": "Total",
        "discount_placeholder": "Discount code",
        "discount_apply": "Apply",
        "discount_remove": "Remove discount code",
        "discount_invalid": "This code is invalid or has expired.",
        "discount_min_order": "This code requires an order of at least {amount}.",
        "free_shipping_from": "Free delivery from {amount}",
        "free_shipping_missing": "{amount} away from free delivery",
        "free_shipping_reached": "You've got free delivery!",
        "shipping_details_heading": "Shipping details",
        "saved_address_select": "Choose a saved address",
        "want_invoice": "I want a VAT invoice",
        "company_name": "Company name",
        "nip": "Tax ID (NIP)",
        "error_required": "This field is required.",
        "error_email": "Enter a valid email, e.g. jan@example.com.",
        "error_phone": "This number is not valid for the selected country.",
        "error_first_name": "First name may only contain letters.",
        "error_last_name": "Last name may only contain letters.",
        "error_zip": "Postal code must be in the 00-000 format.",
        "error_nip": "Tax ID must have exactly 10 digits.",
        "shipping_info_title": "Shipping and payment methods.",
        "shipping_info_subtitle": "Shipping",
        "shipping_info_country": "Poland",
        "shipping_info_dispatch": "Orders placed by <b>2 pm (Mon–Fri)</b> ship the same day; later orders ship the next business day.",
        "shipping_info_free": "Free delivery from <b>{amount}</b> on every delivery method.",
        "shipping_info_courier_payment": "Pay online with PayU (BLIK, card, Google Pay) or by bank transfer.",
        "shipping_info_price": "Delivery cost: <b>{price}</b>",
        "shipping_info_more": "More information",
        "shipping_info_invoices": "VAT invoices are issued on request.",
        "shipping_info_poland_only": "We only ship within Poland.",
        "product_shipping_time": "Ships within 24 h (orders placed by 2 pm on business days).",
        "product_shipping_free": "Free delivery from 200 zł.",
        "product_shipping_returns": "14 days for free returns.",
        "product_shipping_more": "See full shipping and payment information →",
        "how_to_use_step1": "Spray from 10–15 cm away, aiming at pulse points: wrists, neck, décolleté.",
        "how_to_use_step2": "Don't rub your skin after applying – it breaks the notes down faster.",
        "how_to_use_step3": "Apply to moisturised skin so the scent lasts longer.",
        "how_to_use_step4": "Store in a cool, shaded place away from direct sunlight.",
        "ingredients_intro": "Our perfumes are made from carefully selected fragrance essences dissolved in high-quality cosmetic alcohol (Alcohol Denat.), with no added colourants.",
        "ingredients_alcohol": "Alcohol Denat. – fragrance base",
        "ingredients_parfum": "Parfum (Fragrance) – fragrance composition",
        "ingredients_aqua": "Aqua (Water)",
        "ingredients_allergens": "May contain: Limonene, Linalool, Citral – natural fragrance components",
        "ingredients_note": "The full ingredient list (INCI) is printed on the product label.",
        "essences_show_more": "Show more",
        "essences_show_less": "Show less",
        "profile_add_address": "Add address",
        "address_save_failed": "Could not save the address.",
        "cart_item_sold_out": "“{title}” is no longer available — we've marked it in your cart.",
        "cart_item_reduced": "We reduced “{title}” to {count} — that's all we have in stock.",
        "cart_has_unavailable": "Your cart contains unavailable products. Remove them to continue.",
        "cart_remove_unavailable": "Remove unavailable",
        "phone_country": "Country",
        "error_city_mismatch": "This town doesn't match postal code {zip}. Pick it from the list.",
        "error_city_unknown": "We don't recognise this town. Check the name and postal code.",
        "city_pick_hint": "Pick the town for this postal code from the list.",
        "shipping_poland_only_hint": "We only ship within Poland.",
        "postal_data_attribution": "Postal code data: <geonames>© GeoNames</geonames>, licensed under <license>CC BY 4.0</license>",
        "badge_new": "New"
    },

    fr: {
        "Mężczyzna": "Homme",
        "Kobieta": "Femme",
        "Luksusowe": "Luxe",
        "man": "Homme",
        "woman": "Femme",
        "homepage": "Accueil",
        "about": "À propos",
        "contact": "Contact",
        "stores": "Magasins",
        "policy": "Politique de confidentialité",
        "terms": "Conditions",
        "returns": "Retours",
        "shipping": "Livraison",
        "cart": "Panier",
        "add_to_cart": "Ajouter au panier",
        "add_to_wishlist": "Ajouter à la liste de souhaits",
        "add_to_compare": "Ajouter à la comparaison",
        "links": "Liens",
        "categories": "Catégories",
        "informations": "Informations",
        "luxury": "Luxe",
        "new_arrivals": "Nouveautés",
        "featured_products": "Produits en vedette",
        "products_in_cart": "Produits dans votre panier",
        "subtotal": "Sous-total",
        "register": "S'inscrire",
        "reset_cart": "Réinitialiser le panier",
        "title_az": "Titre (A-Z)",
        "title_za": "Titre (Z-A)",
        "price_high_low": "Prix (du plus élevé au plus bas)",
        "price_low_high": "Prix (du plus bas au plus élevé)",
        "profile": "Profil",
        "login": "Se connecter",
        "logout": "Se déconnecter",
        "checkout": "Paiement",
        "first_name": "Prénom",
        "last_name": "Nom",
        "phone": "Téléphone",
        "company": "Entreprise",
        "postal_code": "Code postal",
        "address": "Adresse",
        "city": "Ville",
        "country": "Pays",
        "place_order": "Passer commande",
        "order_summary": "Résumé de la commande",
        "shipping_next": "Frais de port calculés à l'étape suivante",
        "platnosc": "Paiement",
        "bezpieczenstwo": "Sécurité",
        "dostawa": "Livraison",
        "invoices": "Factures",
        "regulations": "Règlements",
        "your_cart_products": "Vos produits",
        "cart_is_empty": "Votre panier est vide.",
        "continue_shopping": "Continuer mes achats",
        "remove_item": "Retirer",
        "shipping_at_checkout": "Livraison calculée lors du paiement.",
        "add_to_bag": "Ajouter au panier",
        "discover_collection": "Découvrir la collection",
        "essences_eyebrow": "Familles olfactives",
        "essences_title": "Découvrez votre essence",
        "reviews_cta": "Découvrez les avis clients ou notez notre boutique",
        "reviews_heading": "Avis",
        "read_reviews": "Lire les avis",
        "add_review": "Ajouter un avis",
        "no_reviews": "Aucun avis pour le moment. Soyez le premier à en laisser un !",
        "rate_product": "Notez notre produit !",
        "rate_store": "Notez notre boutique !",
        "review_title_placeholder": "Titre",
        "review_name_placeholder": "Votre nom",
        "review_comment_placeholder": "Quel est votre avis ?",
        "submit_review": "Envoyer l'avis",
        "review_success_message": "Merci ! Votre avis est en attente d'approbation.",
        "review_login_required": "Vous devez être connecté pour ajouter un avis.",
        "review_submit_error": "Impossible d'ajouter l'avis.",
        "review_error_prefix": "Une erreur est survenue : ",
        "wishlist_title": "Votre liste de souhaits",
        "wishlist_create_prompt": "Vous voulez créer une liste de souhaits ?",
        "wishlist_join_cta": "Rejoignez-nous et créez votre liste de souhaits !",
        "wishlist_have_account": "Vous avez déjà un compte ?",
        "wishlist_login_cta": "Connectez-vous et créez votre liste de souhaits !",
        "wishlist_desc": "Vos produits enregistrés pour plus tard",
        "wishlist_empty": "Votre liste de souhaits est vide",
        "wishlist_start_shopping": "Commencer vos achats",
        "profile_my_orders": "Mes commandes",
        "profile_my_addresses": "Mes adresses",
        "profile_my_invoices": "Mes factures",
        "profile_settings": "Paramètres",
        "profile_logout": "Déconnexion",
        "profile_order_history": "Historique des commandes",
        "profile_addresses_heading": "Adresses",
        "profile_no_addresses": "Aucune adresse ajoutée",
        "edit": "Modifier",
        "delete": "Supprimer",
        "wishlist_login_required": "Connectez-vous pour ajouter à la liste de souhaits.",
        "wishlist_added": "Ajouté à la liste de souhaits !",
        "wishlist_already_added": "Produit déjà dans la liste de souhaits.",
        "wishlist_add_failed": "Échec de l'ajout à la liste de souhaits.",
        "wishlist_view_product": "Voir le produit",
        "wishlist_remove": "Retirer",
        "wishlist_remove_failed": "Échec de la suppression de la liste de souhaits.",
        "loading": "Chargement...",
        "product_not_found": "Produit introuvable !",
        "out_of_stock": "Rupture de stock !",
        "add_to_cart_prefix": "Ajouter au panier - ",
        "ratings_and_reviews": "Évaluations et avis",
        "notes_accordion_title": "NOTES OLFACTIVES",
        "composition_accordion_title": "COMPOSITION",
        "how_to_use_accordion_title": "MODE D'EMPLOI",
        "shipping_accordion_title": "LIVRAISON",
        "top_notes_label": "Les premières notes que vous sentirez :",
        "heart_notes_label": "Le cœur du parfum :",
        "base_notes_label": "Les notes qui persistent toute la journée :",
        "reviews_count_suffix": "avis",
        "similar_products_heading": "Vous aimerez aussi :",
        "add_button_short": "Ajouter",
        "badge_new": "Nouveau"
    },

    de: {
        "Mężczyzna": "Mann",
        "Kobieta": "Frau",
        "Luksusowe": "Luxe",
        "man": "Mann",
        "woman": "Frau",
        "homepage": "Startseite",
        "about": "Über uns",
        "contact": "Kontakt",
        "stores": "Geschäfte",
        "policy": "Datenschutzrichtlinie",
        "terms": "Bedingungen",
        "returns": "Rücksendungen",
        "shipping": "Versand",
        "cart": "Warenkorb",
        "add_to_cart": "In den Warenkorb",
        "add_to_wishlist": "Zur Wunschliste",
        "add_to_compare": "Zum Vergleichen hinzufügen",
        "links": "Links",
        "categories": "Kategorien",
        "informations": "Informationen",
        "luxury": "Luxus",
        "new_arrivals": "Neuheiten",
        "featured_products": "Empfohlene Produkte",
        "products_in_cart": "Produkte im Warenkorb",
        "subtotal": "Zwischensumme",
        "register": "Registrieren",
        "reset_cart": "Warenkorb zurücksetzen",
        "title_az": "Titel (A-Z)",
        "title_za": "Titel (Z-A)",
        "price_high_low": "Preis (hoch bis niedrig)",
        "price_low_high": "Preis (niedrig bis hoch)",
        "profile": "Profil",
        "login": "Anmelden",
        "logout": "Abmelden",
        "checkout": "Zur Kasse",
        "first_name": "Vorname",
        "last_name": "Nachname",
        "phone": "Telefon",
        "company": "Firma",
        "postal_code": "Postleitzahl",
        "address": "Adresse",
        "city": "Stadt",
        "country": "Land",
        "place_order": "Bestellung aufgeben",
        "order_summary": "Bestellübersicht",
        "shipping_next": "Versandkosten im nächsten Schritt berechnet",
        "platnosc": "Zahlung",
        "bezpieczenstwo": "Sicherheit",
        "dostawa": "Lieferung",
        "invoices": "Rechnungen",
        "regulations": "Vorschriften",
        "your_cart_products": "Ihre Produkte",
        "cart_is_empty": "Ihr Warenkorb ist leer.",
        "continue_shopping": "Weiter einkaufen",
        "remove_item": "Entfernen",
        "shipping_at_checkout": "Versandkosten werden an der Kasse berechnet.",
        "add_to_bag": "In den Warenkorb",
        "discover_collection": "Kollektion entdecken",
        "essences_eyebrow": "Duftfamilien",
        "essences_title": "Entdecken Sie Ihre Essenz",
        "reviews_cta": "Kundenbewertungen ansehen oder unseren Shop bewerten",
        "reviews_heading": "Bewertungen",
        "read_reviews": "Bewertungen lesen",
        "add_review": "Bewertung hinzufügen",
        "no_reviews": "Noch keine Bewertungen. Seien Sie der Erste!",
        "rate_product": "Bewerten Sie unser Produkt!",
        "rate_store": "Bewerten Sie unseren Shop!",
        "review_title_placeholder": "Titel",
        "review_name_placeholder": "Ihr Name",
        "review_comment_placeholder": "Was ist Ihre Meinung?",
        "submit_review": "Bewertung senden",
        "review_success_message": "Danke! Ihre Bewertung wartet auf Freigabe.",
        "review_login_required": "Sie müssen angemeldet sein, um eine Bewertung hinzuzufügen.",
        "review_submit_error": "Bewertung konnte nicht hinzugefügt werden.",
        "review_error_prefix": "Ein Fehler ist aufgetreten: ",
        "wishlist_title": "Deine Wunschliste",
        "wishlist_create_prompt": "Möchtest du eine Wunschliste erstellen?",
        "wishlist_join_cta": "Werde Mitglied und erstelle deine Wunschliste!",
        "wishlist_have_account": "Hast du bereits ein Konto?",
        "wishlist_login_cta": "Melde dich an und erstelle deine Wunschliste!",
        "wishlist_desc": "Deine für später gespeicherten Produkte",
        "wishlist_empty": "Deine Wunschliste ist leer",
        "wishlist_start_shopping": "Jetzt einkaufen",
        "profile_my_orders": "Meine Bestellungen",
        "profile_my_addresses": "Meine Adressen",
        "profile_my_invoices": "Meine Rechnungen",
        "profile_settings": "Einstellungen",
        "profile_logout": "Abmelden",
        "profile_order_history": "Bestellverlauf",
        "profile_addresses_heading": "Adressen",
        "profile_no_addresses": "Keine Adressen hinzugefügt",
        "edit": "Bearbeiten",
        "delete": "Löschen",
        "wishlist_login_required": "Melde dich an, um zur Wunschliste hinzuzufügen.",
        "wishlist_added": "Zur Wunschliste hinzugefügt!",
        "wishlist_already_added": "Produkt bereits auf der Wunschliste.",
        "wishlist_add_failed": "Hinzufügen zur Wunschliste fehlgeschlagen.",
        "wishlist_view_product": "Produkt ansehen",
        "wishlist_remove": "Entfernen",
        "wishlist_remove_failed": "Entfernen von der Wunschliste fehlgeschlagen.",
        "loading": "Wird geladen...",
        "product_not_found": "Produkt nicht gefunden!",
        "out_of_stock": "Nicht auf Lager!",
        "add_to_cart_prefix": "In den Warenkorb - ",
        "ratings_and_reviews": "Bewertungen und Rezensionen",
        "notes_accordion_title": "DUFTNOTEN",
        "composition_accordion_title": "ZUSAMMENSETZUNG",
        "how_to_use_accordion_title": "ANWENDUNG",
        "shipping_accordion_title": "VERSAND",
        "top_notes_label": "Die ersten Noten, die du wahrnimmst:",
        "heart_notes_label": "Das Herz des Parfums:",
        "base_notes_label": "Die Noten, die den ganzen Tag anhalten:",
        "reviews_count_suffix": "Bewertungen",
        "similar_products_heading": "Das könnte dir auch gefallen:",
        "add_button_short": "Hinzufügen",
        "badge_new": "Neu"
    },

    sp: {
        "Mężczyzna": "Hombre",
        "Kobieta": "Mujer",
        "Luksusowe": "Lujo",
        "man": "Hombre",
        "woman": "Mujer",
        "homepage": "Página principal",
        "about": "Acerca de",
        "contact": "Contacto",
        "stores": "Tiendas",
        "policy": "Política de privacidad",
        "terms": "Términos",
        "returns": "Devoluciones",
        "shipping": "Envío",
        "cart": "Carrito",
        "add_to_cart": "Añadir al carrito",
        "add_to_wishlist": "Añadir a la lista de deseos",
        "add_to_compare": "Añadir para comparar",
        "links": "Enlaces",
        "categories": "Categorías",
        "informations": "Informaciones",
        "luxury": "Lujo",
        "new_arrivals": "Novedades",
        "featured_products": "Productos destacados",
        "products_in_cart": "Productos en tu carrito",
        "subtotal": "Subtotal",
        "register": "Registrarse",
        "reset_cart": "Reiniciar carrito",
        "title_az": "Título (A-Z)",
        "title_za": "Título (Z-A)",
        "price_high_low": "Precio (de mayor a menor)",
        "price_low_high": "Precio (de menor a mayor)",
        "profile": "Perfil",
        "login": "Iniciar sesión",
        "logout": "Cerrar sesión",
        "checkout": "Pagar",
        "first_name": "Nombre",
        "last_name": "Apellido",
        "phone": "Teléfono",
        "company": "Empresa",
        "postal_code": "Código postal",
        "address": "Dirección",
        "city": "Ciudad",
        "country": "País",
        "place_order": "Realizar pedido",
        "order_summary": "Resumen del pedido",
        "shipping_next": "El envío se calculará en el siguiente paso",
        "platnosc": "Pago",
        "bezpieczenstwo": "Seguridad",
        "dostawa": "Entrega",
        "invoices": "Facturas",
        "regulations": "Regulaciones",
        "your_cart_products": "Tus productos",
        "cart_is_empty": "Tu carrito está vacío.",
        "continue_shopping": "Seguir comprando",
        "remove_item": "Eliminar",
        "shipping_at_checkout": "Envío calculado al pagar.",
        "add_to_bag": "Añadir a la cesta",
        "discover_collection": "Descubrir la colección",
        "essences_eyebrow": "Familias olfativas",
        "essences_title": "Descubre tu esencia",
        "reviews_cta": "Descubre las opiniones de los clientes o valora nuestra tienda",
        "reviews_heading": "Opiniones",
        "read_reviews": "Leer opiniones",
        "add_review": "Añadir opinión",
        "no_reviews": "Aún no hay opiniones. ¡Sé el primero en dejar una!",
        "rate_product": "¡Valora nuestro producto!",
        "rate_store": "¡Valora nuestra tienda!",
        "review_title_placeholder": "Título",
        "review_name_placeholder": "Tu nombre",
        "review_comment_placeholder": "¿Cuáles son tus comentarios?",
        "submit_review": "Enviar opinión",
        "review_success_message": "¡Gracias! Tu opinión está pendiente de aprobación.",
        "review_login_required": "Debes iniciar sesión para añadir una opinión.",
        "review_submit_error": "No se pudo añadir la opinión.",
        "review_error_prefix": "Se produjo un error: ",
        "wishlist_title": "Tu lista de deseos",
        "wishlist_create_prompt": "¿Quieres crear una lista de deseos?",
        "wishlist_join_cta": "¡Únete a nosotros y crea tu lista de deseos!",
        "wishlist_have_account": "¿Ya tienes una cuenta?",
        "wishlist_login_cta": "¡Inicia sesión y crea tu lista de deseos!",
        "wishlist_desc": "Tus productos guardados para más tarde",
        "wishlist_empty": "Tu lista de deseos está vacía",
        "wishlist_start_shopping": "Empezar a comprar",
        "profile_my_orders": "Mis pedidos",
        "profile_my_addresses": "Mis direcciones",
        "profile_my_invoices": "Mis facturas",
        "profile_settings": "Ajustes",
        "profile_logout": "Cerrar sesión",
        "profile_order_history": "Historial de pedidos",
        "profile_addresses_heading": "Direcciones",
        "profile_no_addresses": "No se han añadido direcciones",
        "edit": "Editar",
        "delete": "Eliminar",
        "wishlist_login_required": "Inicia sesión para añadir a la lista de deseos.",
        "wishlist_added": "¡Añadido a la lista de deseos!",
        "wishlist_already_added": "El producto ya está en la lista de deseos.",
        "wishlist_add_failed": "Error al añadir a la lista de deseos.",
        "wishlist_view_product": "Ver producto",
        "wishlist_remove": "Eliminar",
        "wishlist_remove_failed": "Error al eliminar de la lista de deseos.",
        "loading": "Cargando...",
        "product_not_found": "¡Producto no encontrado!",
        "out_of_stock": "¡Agotado!",
        "add_to_cart_prefix": "Añadir al carrito - ",
        "ratings_and_reviews": "Valoraciones y opiniones",
        "notes_accordion_title": "NOTAS OLFATIVAS",
        "composition_accordion_title": "COMPOSICIÓN",
        "how_to_use_accordion_title": "CÓMO USAR",
        "shipping_accordion_title": "ENVÍO",
        "top_notes_label": "Las primeras notas que percibirás:",
        "heart_notes_label": "El corazón del perfume:",
        "base_notes_label": "Las notas que perduran todo el día:",
        "reviews_count_suffix": "opiniones",
        "similar_products_heading": "También te puede gustar:",
        "add_button_short": "Añadir",
        "badge_new": "Nuevo"
    },

    hi: {
        "Mężczyzna": "पुरुष",
        "Kobieta": "महिला",
        "Luksusowe": "लक्ज़री",
        "man": "पुरुष",
        "woman": "महिला",
        "homepage": "मुखपृष्ठ",
        "about": "हमारे बारे में",
        "contact": "संपर्क",
        "stores": "स्टोर",
        "policy": "गोपनीयता नीति",
        "terms": "नियम",
        "returns": "वापसी",
        "shipping": "शिपिंग",
        "cart": "कार्ट",
        "add_to_cart": "कार्ट में जोड़ें",
        "add_to_wishlist": "इच्छा सूची में जोड़ें",
        "add_to_compare": "तुलना करें में जोड़ें",
        "links": "लिंक",
        "categories": "श्रेणियाँ",
        "informations": "जानकारी",
        "luxury": "विलासिता",
        "new_arrivals": "नई आगमन",
        "featured_products": "विशेष उत्पाद",
        "products_in_cart": "आपके कार्ट में उत्पाद",
        "subtotal": "उप-योग",
        "register": "पंजीकरण करें",
        "reset_cart": "कार्ट रीसेट करें",
        "title_az": "शीर्षक (A-Z)",
        "title_za": "शीर्षक (Z-A)",
        "price_high_low": "मूल्य (उच्च से निम्न)",
        "price_low_high": "मूल्य (निम्न से उच्च)",
        "profile": "प्रोफ़ाइल",
        "login": "लॉग इन करें",
        "logout": "लॉग आउट",
        "checkout": "चेकआउट",
        "first_name": "पहला नाम",
        "last_name": "अंतिम नाम",
        "phone": "फ़ोन",
        "company": "कंपनी",
        "postal_code": "डाक कोड",
        "address": "पता",
        "city": "शहर",
        "country": "देश",
        "place_order": "ऑर्डर करें",
        "order_summary": "आदेश सारांश",
        "shipping_next": "शिपिंग अगले चरण में गणना की जाएगी",
        "platnosc": "भुगतान",
        "bezpieczenstwo": "सुरक्षा",
        "dostawa": "डिलीवरी",
        "invoices": "चालान",
        "regulations": "नियम",
        "your_cart_products": "आपके उत्पाद",
        "cart_is_empty": "आपकी टोकरी खाली है।",
        "continue_shopping": "खरीदारी जारी रखें",
        "remove_item": "हटाएँ",
        "shipping_at_checkout": "शिपिंग चेकआउट पर गणना की जाएगी।",
        "add_to_bag": "बैग में जोड़ें",
        "discover_collection": "संग्रह देखें",
        "essences_eyebrow": "सुगंध परिवार",
        "essences_title": "अपना सार खोजें",
        "reviews_cta": "ग्राहक समीक्षाएं देखें या हमारे स्टोर को रेट करें",
        "reviews_heading": "समीक्षाएं",
        "read_reviews": "समीक्षाएं पढ़ें",
        "add_review": "समीक्षा जोड़ें",
        "no_reviews": "अभी तक कोई समीक्षा नहीं। पहली समीक्षा आप दें!",
        "rate_product": "हमारे उत्पाद को रेट करें!",
        "rate_store": "हमारे स्टोर को रेट करें!",
        "review_title_placeholder": "शीर्षक",
        "review_name_placeholder": "आपका नाम",
        "review_comment_placeholder": "आपकी क्या राय है?",
        "submit_review": "समीक्षा भेजें",
        "review_success_message": "धन्यवाद! आपकी समीक्षा स्वीकृति की प्रतीक्षा में है।",
        "review_login_required": "समीक्षा जोड़ने के लिए आपको लॉग इन करना होगा।",
        "review_submit_error": "समीक्षा जोड़ने में विफल।",
        "review_error_prefix": "एक त्रुटि हुई: ",
        "wishlist_title": "आपकी इच्छा सूची",
        "wishlist_create_prompt": "क्या आप इच्छा सूची बनाना चाहते हैं?",
        "wishlist_join_cta": "हमसे जुड़ें और अपनी इच्छा सूची बनाएं!",
        "wishlist_have_account": "क्या आपका पहले से खाता है?",
        "wishlist_login_cta": "लॉग इन करें और अपनी इच्छा सूची बनाएं!",
        "wishlist_desc": "बाद के लिए सहेजे गए आपके उत्पाद",
        "wishlist_empty": "आपकी इच्छा सूची खाली है",
        "wishlist_start_shopping": "खरीदारी शुरू करें",
        "profile_my_orders": "मेरे ऑर्डर",
        "profile_my_addresses": "मेरे पते",
        "profile_my_invoices": "मेरे चालान",
        "profile_settings": "सेटिंग्स",
        "profile_logout": "लॉग आउट",
        "profile_order_history": "ऑर्डर इतिहास",
        "profile_addresses_heading": "पते",
        "profile_no_addresses": "कोई पता नहीं जोड़ा गया",
        "edit": "संपादित करें",
        "delete": "हटाएं",
        "wishlist_login_required": "इच्छा सूची में जोड़ने के लिए लॉग इन करें।",
        "wishlist_added": "इच्छा सूची में जोड़ा गया!",
        "wishlist_already_added": "उत्पाद पहले से इच्छा सूची में है।",
        "wishlist_add_failed": "इच्छा सूची में जोड़ने में विफल।",
        "wishlist_view_product": "उत्पाद देखें",
        "wishlist_remove": "हटाएं",
        "wishlist_remove_failed": "इच्छा सूची से हटाने में विफल।",
        "loading": "लोड हो रहा है...",
        "product_not_found": "उत्पाद नहीं मिला!",
        "out_of_stock": "स्टॉक में नहीं!",
        "add_to_cart_prefix": "कार्ट में जोड़ें - ",
        "ratings_and_reviews": "रेटिंग और समीक्षाएं",
        "notes_accordion_title": "सुगंध नोट्स",
        "composition_accordion_title": "संरचना",
        "how_to_use_accordion_title": "उपयोग कैसे करें",
        "shipping_accordion_title": "शिपिंग",
        "top_notes_label": "पहली सुगंध नोट्स जिन्हें आप महसूस करेंगे:",
        "heart_notes_label": "इत्र का हृदय:",
        "base_notes_label": "वे नोट्स जो पूरे दिन टिकते हैं:",
        "reviews_count_suffix": "समीक्षाएं",
        "similar_products_heading": "आपको ये भी पसंद आ सकते हैं:",
        "add_button_short": "जोड़ें",
        "badge_new": "नया"
    },

    ru: {
        "Mężczyzna": "Мужчина",
        "Kobieta": "Женщина",
        "Luksusowe": "Роскошь",
        "man": "Мужчина",
        "woman": "Женщина",
        "homepage": "Главная",
        "about": "О нас",
        "contact": "Контакт",
        "stores": "Магазины",
        "policy": "Политика конфиденциальности",
        "terms": "Условия",
        "returns": "Возвраты",
        "shipping": "Доставка",
        "cart": "Корзина",
        "add_to_cart": "Добавить в корзину",
        "add_to_wishlist": "Добавить в список желаний",
        "add_to_compare": "Добавить для сравнения",
        "links": "Ссылки",
        "categories": "Категории",
        "informations": "Информация",
        "luxury": "Роскошь",
        "new_arrivals": "Новинки",
        "featured_products": "Рекомендуемые товары",
        "products_in_cart": "Товары в вашей корзине",
        "subtotal": "Промежуточный итог",
        "register": "Зарегистрироваться",
        "reset_cart": "Очистить корзину",
        "title_az": "Название (A-Z)",
        "title_za": "Название (Z-A)",
        "price_high_low": "Цена (высокая-низкая)",
        "price_low_high": "Цена (низкая-высокая)",
        "profile": "Профиль",
        "login": "Войти",
        "logout": "Выйти",
        "checkout": "Оформить заказ",
        "first_name": "Имя",
        "last_name": "Фамилия",
        "phone": "Телефон",
        "company": "Компания",
        "postal_code": "Почтовый индекс",
        "address": "Адрес",
        "city": "Город",
        "country": "Страна",
        "place_order": "Разместить заказ",
        "order_summary": "Сводка заказа",
        "shipping_next": "Доставка рассчитывается на следующем шаге",
        "platnosc": "Оплата",
        "bezpieczenstwo": "Безопасность",
        "dostawa": "Доставка",
        "invoices": "Счета",
        "regulations": "Правила",
        "your_cart_products": "Ваши товары",
        "cart_is_empty": "Ваша корзина пуста.",
        "continue_shopping": "Продолжить покупки",
        "remove_item": "Удалить",
        "shipping_at_checkout": "Стоимость доставки рассчитывается при оформлении.",
        "add_to_bag": "Добавить в корзину",
        "discover_collection": "Открыть коллекцию",
        "essences_eyebrow": "Семейства ароматов",
        "essences_title": "Откройте свою эссенцию",
        "reviews_cta": "Посмотрите отзывы клиентов или оцените наш магазин",
        "reviews_heading": "Отзывы",
        "read_reviews": "Читать отзывы",
        "add_review": "Добавить отзыв",
        "no_reviews": "Отзывов пока нет. Будьте первым!",
        "rate_product": "Оцените наш товар!",
        "rate_store": "Оцените наш магазин!",
        "review_title_placeholder": "Заголовок",
        "review_name_placeholder": "Ваше имя",
        "review_comment_placeholder": "Поделитесь своим мнением",
        "submit_review": "Отправить отзыв",
        "review_success_message": "Спасибо! Ваш отзыв ожидает одобрения.",
        "review_login_required": "Чтобы оставить отзыв, необходимо войти в систему.",
        "review_submit_error": "Не удалось добавить отзыв.",
        "review_error_prefix": "Произошла ошибка: ",
        "wishlist_title": "Ваш список желаний",
        "wishlist_create_prompt": "Хотите создать список желаний?",
        "wishlist_join_cta": "Присоединяйтесь и создайте свой список желаний!",
        "wishlist_have_account": "Уже есть аккаунт?",
        "wishlist_login_cta": "Войдите и создайте свой список желаний!",
        "wishlist_desc": "Ваши товары, сохранённые на потом",
        "wishlist_empty": "Ваш список желаний пуст",
        "wishlist_start_shopping": "Начать покупки",
        "profile_my_orders": "Мои заказы",
        "profile_my_addresses": "Мои адреса",
        "profile_my_invoices": "Мои счета",
        "profile_settings": "Настройки",
        "profile_logout": "Выйти",
        "profile_order_history": "История заказов",
        "profile_addresses_heading": "Адреса",
        "profile_no_addresses": "Адреса не добавлены",
        "edit": "Изменить",
        "delete": "Удалить",
        "wishlist_login_required": "Войдите, чтобы добавить в список желаний.",
        "wishlist_added": "Добавлено в список желаний!",
        "wishlist_already_added": "Товар уже в списке желаний.",
        "wishlist_add_failed": "Не удалось добавить в список желаний.",
        "wishlist_view_product": "Посмотреть товар",
        "wishlist_remove": "Удалить",
        "wishlist_remove_failed": "Не удалось удалить из списка желаний.",
        "loading": "Загрузка...",
        "product_not_found": "Товар не найден!",
        "out_of_stock": "Нет в наличии!",
        "add_to_cart_prefix": "Добавить в корзину - ",
        "ratings_and_reviews": "Рейтинги и отзывы",
        "notes_accordion_title": "НОТЫ АРОМАТА",
        "composition_accordion_title": "СОСТАВ",
        "how_to_use_accordion_title": "КАК ИСПОЛЬЗОВАТЬ",
        "shipping_accordion_title": "ДОСТАВКА",
        "top_notes_label": "Первые ноты, которые вы почувствуете:",
        "heart_notes_label": "Сердце аромата:",
        "base_notes_label": "Ноты, которые сохраняются весь день:",
        "reviews_count_suffix": "отзывов",
        "similar_products_heading": "Вам также может понравиться:",
        "add_button_short": "Добавить",
        "badge_new": "Новинка"
    },

});

const messageReducer = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state;
    }
};

export default messageReducer;


